var _mask, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_14724",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 71.5C143 86.8299 138.073 101.754 128.946 114.071C119.818 126.387 106.974 135.444 92.3075 139.905C77.6411 144.367 61.9291 143.996 47.4894 138.848C33.0497 133.7 20.6469 124.047 12.1106 111.314C3.57429 98.5805 -0.643444 83.4407 0.0795655 68.1278C0.802575 52.8149 6.42804 38.1399 16.1261 26.2675C25.8242 14.395 39.0813 5.95394 53.9418 2.18939C68.8024 -1.57517 84.4794 -0.463831 98.6602 5.35945L98.1514 6.59842C84.2362 0.884221 68.8529 -0.206296 54.2707 3.48774C39.6886 7.18177 26.6798 15.4647 17.1634 27.1148C7.647 38.7648 2.1269 53.165 1.41744 68.191C0.707972 83.217 4.8467 98.0732 13.2231 110.568C21.5995 123.063 33.77 132.535 47.9392 137.586C62.1084 142.638 77.5261 143.002 91.9178 138.624C106.309 134.246 118.913 125.359 127.869 113.273C136.826 101.187 141.661 86.5428 141.661 71.5H143Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143 71.5C143 86.8299 138.073 101.754 128.946 114.071C119.818 126.387 106.974 135.444 92.3075 139.905C77.6411 144.367 61.9291 143.996 47.4894 138.848C33.0497 133.7 20.6469 124.047 12.1106 111.314C3.57429 98.5805 -0.643444 83.4407 0.0795655 68.1278C0.802575 52.8149 6.42804 38.1399 16.1261 26.2675C25.8242 14.395 39.0813 5.95394 53.9418 2.18939C68.8024 -1.57517 84.4794 -0.463831 98.6602 5.35945L98.1514 6.59842C84.2362 0.884221 68.8529 -0.206296 54.2707 3.48774C39.6886 7.18177 26.6798 15.4647 17.1634 27.1148C7.647 38.7648 2.1269 53.165 1.41744 68.191C0.707972 83.217 4.8467 98.0732 13.2231 110.568C21.5995 123.063 33.77 132.535 47.9392 137.586C62.1084 142.638 77.5261 143.002 91.9178 138.624C106.309 134.246 118.913 125.359 127.869 113.273C136.826 101.187 141.661 86.5428 141.661 71.5H143Z",
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_1_14724)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 71.5,
    r: 70.75,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67L64 85.1865L64 48.8135L88 67Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.d80e1807d873f0102ddba30561cc8bc1.svg";
export { ForwardRef as ReactComponent };